<template>
<section class="steps-indicator pad-t-40 pad-b-70">
    <div class="headspace hidden-sm hidden-md hidden-lg hidden-xl"></div>

    <div class="w-grid trim text-center">
       
        <div class="w-1">
            <div class="w-grid inline trim gutters-2x">
                <div 
                v-for="(step,index) in steps" 
                v-bind:key="index" 
                v-bind:class="['w-1-4 step-wrap', stepActive==step ? 'active' : '']">
                    <div class="step">{{ step }}</div>
                </div>
            </div>
        </div>
        
    </div>
</section>
</template>


<script>
export default {
    name: 'wewSteps',
    props: {
        stepActive: Number
    },
    data() {
        return {
            steps: [1,2,3,4]
        }
    }
}
</script>

<style scoped="true">
.headspace{
  height: 64px;
}

.step-wrap{
    position: relative;
}
.step-wrap:before{
    position: absolute;
    content: "";
    top: 5px;
    left: 50%;
    margin-left: -25px;
    width: 50px;
    height: 50px;
    border-radius: 50px;
    -webkit-box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow:    inset 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
    box-shadow:         inset 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
}

.step-wrap.active:before{
    display: none;
}
.step{
    font-family: 'Brandon Grotesque', sans-serif;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    background-color: white;
    color: #2AAAE5;
    font-size: 36px;
    line-height: 36px;
    padding: 8px 0;
    font-weight: 800;
    border: 6px solid white;
    -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow:    0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow:         0px 4px 10px 0px rgba(0, 0, 0, 0.3);
}

.active .step{
    background-color: #2AAAE5;
    color: white;
}
</style>
